import {WorkspaceResource} from '../../../@types/workspace-types';
import {ResourceType} from '../../../@types/resource-type';
import {BasicPage} from '../../../@types/spring-data-page';
import {Moment} from 'moment';
import React from 'react';

/**
 * Props for the Explorer component
 */
export interface ExplorerProps {
    exploreMode: boolean;
    label: string;
    type: ResourceType;
    objects: WorkspaceResource | null;
    additionalResources?: WorkspaceResource;
    onClickNew: React.MouseEventHandler<HTMLButtonElement>;
    onClickItem: (event: React.MouseEvent<HTMLElement>) => void;
    loadObjects: (
        setLoading: (loading: boolean) => void,
        page: BasicPage,
        selectedResource: number,
        searchText: string,
        startDate?: Moment | null,
        endDate?: Moment | null,
        descriptorType?: number
    ) => void;
    setObjects: (objects: WorkspaceResource | null) => void;
}

/**
 * Order type for sorting
 */
export type Order = 'asc' | 'desc';

/**
 * Descriptor types for occurrence report descriptors
 */
export const DESCRIPTOR_TYPES = [
    { id: 0, name: 'All' },
    { id: 1, name: 'Draft' },
    { id: 2, name: 'Published' },
];

/**
 * Page size options
 */
export const PAGE_SIZES: number[] = [25, 50, 100, 150];